import { render, staticRenderFns } from "./ImageWithTextRight.vue?vue&type=template&id=9502064a"
import script from "./ImageWithTextRight.vue?vue&type=script&lang=js"
export * from "./ImageWithTextRight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ContainerContent: require('/vercel/path0/components/shared/ContainerContent.vue').default})
